import React from 'react';

const PrivacyPage: React.FC = () => {
  return (
    <main>
      <div className="container">
        <div style={{ marginTop: '120px', marginBottom: '50px' }}>
          <h1 className="section-title">Privacy Policy</h1>
          
          <div style={{ marginTop: '30px', lineHeight: '1.6' }}>
            <p style={{ marginBottom: '20px' }}>
              Last Updated: April 1, 2025
            </p>
            
            <p style={{ marginBottom: '20px' }}>
              At Quick Flick, we take your privacy seriously. This Privacy Policy explains how we collect, use, disclose, and safeguard your information 
              when you use our streaming service. Please read this privacy policy carefully. If you do not agree with the terms of this privacy policy, 
              please do not access the service.
            </p>
            
            <h2 style={{ fontSize: '1.5rem', margin: '30px 0 15px' }}>1. Information We Collect</h2>
            <p style={{ marginBottom: '15px' }}>
              We collect several different types of information for various purposes to provide and improve our service to you:
            </p>
            
            <div style={{ marginLeft: '20px', marginBottom: '20px' }}>
              <h3 style={{ fontSize: '1.2rem', margin: '15px 0 10px' }}>1.1 Personal Data</h3>
              <p style={{ marginBottom: '10px' }}>
                While using our service, we may ask you to provide us with certain personally identifiable information that can be used to contact or 
                identify you ("Personal Data"). This may include, but is not limited to:
              </p>
              <ul style={{ marginLeft: '20px', marginBottom: '15px', listStyleType: 'disc' }}>
                <li>Email address</li>
                <li>First name and last name</li>
                <li>Phone number</li>
                <li>Address, State, Province, ZIP/Postal code, City</li>
                <li>Cookies and Usage Data</li>
                <li>Payment information</li>
              </ul>
              
              <h3 style={{ fontSize: '1.2rem', margin: '15px 0 10px' }}>1.2 Usage Data</h3>
              <p style={{ marginBottom: '10px' }}>
                We also collect information on how the service is accessed and used ("Usage Data"). This data may include information such as your 
                computer's Internet Protocol address (IP address), browser type, browser version, the pages of our service that you visit, the time 
                and date of your visit, the time spent on those pages, unique device identifiers, and other diagnostic data.
              </p>
              
              <h3 style={{ fontSize: '1.2rem', margin: '15px 0 10px' }}>1.3 Tracking & Cookies Data</h3>
              <p style={{ marginBottom: '10px' }}>
                We use cookies and similar tracking technologies to track activity on our service and hold certain information. Cookies are files with 
                a small amount of data that may include an anonymous unique identifier. You can instruct your browser to refuse all cookies or to indicate 
                when a cookie is being sent.
              </p>
            </div>
            
            <h2 style={{ fontSize: '1.5rem', margin: '30px 0 15px' }}>2. How We Use Your Information</h2>
            <p style={{ marginBottom: '15px' }}>
              Quick Flick uses the collected data for various purposes:
            </p>
            <ul style={{ marginLeft: '20px', marginBottom: '20px', listStyleType: 'disc' }}>
              <li>To provide and maintain our service</li>
              <li>To notify you about changes to our service</li>
              <li>To allow you to participate in interactive features of our service when you choose to do so</li>
              <li>To provide customer support</li>
              <li>To gather analysis or valuable information so that we can improve our service</li>
              <li>To monitor the usage of our service</li>
              <li>To detect, prevent and address technical issues</li>
              <li>To personalize the content we show you, including recommendations</li>
              <li>To process payments</li>
            </ul>
            
            <h2 style={{ fontSize: '1.5rem', margin: '30px 0 15px' }}>3. Disclosure of Data</h2>
            <p style={{ marginBottom: '15px' }}>
              We may disclose your Personal Data in the good faith belief that such action is necessary to:
            </p>
            <ul style={{ marginLeft: '20px', marginBottom: '20px', listStyleType: 'disc' }}>
              <li>Comply with a legal obligation</li>
              <li>Protect and defend the rights or property of Quick Flick</li>
              <li>Prevent or investigate possible wrongdoing in connection with the service</li>
              <li>Protect the personal safety of users of the service or the public</li>
              <li>Protect against legal liability</li>
            </ul>
            <p style={{ marginBottom: '15px' }}>
              We may also share your information with third-party service providers who perform services on our behalf, such as payment processing, 
              data analysis, email delivery, hosting services, customer service, and marketing assistance.
            </p>
            
            <h2 style={{ fontSize: '1.5rem', margin: '30px 0 15px' }}>4. Security of Data</h2>
            <p style={{ marginBottom: '15px' }}>
              The security of your data is important to us, but remember that no method of transmission over the Internet, or method of electronic 
              storage is 100% secure. While we strive to use commercially acceptable means to protect your Personal Data, we cannot guarantee its 
              absolute security.
            </p>
            
            <h2 style={{ fontSize: '1.5rem', margin: '30px 0 15px' }}>5. Your Data Protection Rights</h2>
            <p style={{ marginBottom: '15px' }}>
              Depending on your location, you may have certain rights regarding your personal information, such as:
            </p>
            <ul style={{ marginLeft: '20px', marginBottom: '20px', listStyleType: 'disc' }}>
              <li>The right to access the personal information we have about you</li>
              <li>The right to request correction of inaccurate personal information</li>
              <li>The right to request deletion of your personal information</li>
              <li>The right to object to processing of your personal information</li>
              <li>The right to data portability</li>
              <li>The right to withdraw consent</li>
            </ul>
            <p style={{ marginBottom: '15px' }}>
              To exercise any of these rights, please contact us using the contact information provided below.
            </p>
            
            <h2 style={{ fontSize: '1.5rem', margin: '30px 0 15px' }}>6. Children's Privacy</h2>
            <p style={{ marginBottom: '15px' }}>
              Our service is not intended for use by children under the age of 13. We do not knowingly collect personally identifiable information from 
              children under 13. If you are a parent or guardian and you are aware that your child has provided us with Personal Data, please contact us.
            </p>
            
            <h2 style={{ fontSize: '1.5rem', margin: '30px 0 15px' }}>7. Changes to This Privacy Policy</h2>
            <p style={{ marginBottom: '15px' }}>
              We may update our Privacy Policy from time to time. We will notify you of any changes by posting the new Privacy Policy on this page and 
              updating the "Last Updated" date. You are advised to review this Privacy Policy periodically for any changes.
            </p>
            
            <h2 style={{ fontSize: '1.5rem', margin: '30px 0 15px' }}>8. International Transfers</h2>
            <p style={{ marginBottom: '15px' }}>
              Your information, including Personal Data, may be transferred to — and maintained on — computers located outside of your state, province, 
              country or other governmental jurisdiction where the data protection laws may differ from those of your jurisdiction. 
              If you are located outside the United States and choose to provide information to us, please note that we transfer the data, 
              including Personal Data, to the United States and process it there.
            </p>
            
            <div style={{ 
              background: 'var(--secondary-color)',
              padding: '30px',
              borderRadius: '8px',
              marginTop: '40px'
            }}>
              <h2 style={{ marginBottom: '15px' }}>Contact Us</h2>
              <p style={{ marginBottom: '20px' }}>
                If you have any questions about this Privacy Policy, please contact us:
              </p>
              <ul style={{ marginLeft: '20px', marginBottom: '15px', listStyleType: 'disc' }}>
                <li>By email: <a href="mailto:privacy@quickflick.com" style={{ color: 'var(--primary-color)' }}>privacy@quickflick.com</a></li>
                <li>By visiting our <a href="/contact" style={{ color: 'var(--primary-color)' }}>contact page</a></li>
                <li>By mail: Quick Flick, 123 Streaming Lane, San Francisco, CA 94105, United States</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </main>
  );
};

export default PrivacyPage; 